(function() {
    // Only run on devices that support true hover (desktop)
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.addEventListener('DOMContentLoaded', function() {
        var items = document.querySelectorAll('.collaboration-item');

        items.forEach(function(item) {
            var preview = item.querySelector('.collaboration-item__video-preview');
            if (!preview) return;

            var video = preview.querySelector('video');

            function onMouseMove(e) {
                preview.style.transform = 'translate(calc(-50% + ' + e.clientX + 'px), calc(-60% + ' + e.clientY + 'px))';
            }

            item.addEventListener('mouseenter', function(e) {
                preview.classList.add('is-visible');
                if (video) {
                    video.currentTime = 0;
                    video.play();
                }
                onMouseMove(e);
            });

            item.addEventListener('mousemove', onMouseMove);

            item.addEventListener('mouseleave', function() {
                preview.classList.remove('is-visible');
                if (video) video.pause();
            });
        });
    });
})();
